import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, List, ListItem, ListItemText, makeStyles, ListItemSecondaryAction, AppBar, Tabs, Tab, Box, Icon, Button, IconButton, Paper } from '@material-ui/core';
import Skeleton from '@material-ui/lab/esm/Skeleton';
import moment from 'moment';
import { history } from '../../helpers/history';
import Typography from '@material-ui/core/Typography';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import Avatar from '@material-ui/core/Avatar';
import { isMobile } from 'react-device-detect';
import { ArrowForwardIos } from '@material-ui/icons';
import { useSelector } from 'react-redux';


const useStyles = makeStyles((theme) => ({
  styleAll: {
    padding: "8px 12px",
    height: "100%",
    // backgroundColor: '#ffffff',
    borderRadius: "16px",
    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
  },
  listItems: {
    color: 'rgb(65, 65, 65)',
    fontSize: '0.875rem',
    //fontFamily: 'Roboto-Regular',
    backgroundColor: "#ffffff",
  },
  submit: {
    margin: (3, 0, 2),
    fontWeight: 'bold',
    fontSize: '0.6rem',
    color: '#ffffff',
    backgroundColor: "#B48518",
    width: "200px",
    //fontFamily: 'Roboto-Medium',
    "&:hover": {
      backgroundColor: "#B48518",
    }
  },
  texttittleaccounts: {
    fontSize: '1.2rem',
    color: '#ffffff',
  },
  textaccounts: {
    [theme.breakpoints.up('xs')]: {
      fontSize: '100%',
      //fontFamily: 'Roboto-Bold',
      color: '#000000'
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '100%',
      //fontFamily: 'Roboto-Bold',

      color: '#000000'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '100%',
      //fontFamily: 'Roboto-Bold',

      color: '#000000'
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '100%',
      //fontFamily: 'Roboto-Bold',

      color: '#000000'
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '100%',
      //fontFamily: 'Roboto-Bold',

      color: '#000000'
    }
  },
  textAccountsMobile: {
    fontSize: '0.8rem',
    color: '#898989',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.2rem',
    },
  },
  logo: {
    [theme.breakpoints.up('xs')]: {
      width: `35px`,
    },
    [theme.breakpoints.up('sm')]: {
      width: `60%`,
    },
    [theme.breakpoints.up('md')]: {
      width: `60%`,
    },
    [theme.breakpoints.up('lg')]: {
      width: `60%`,
    },
    [theme.breakpoints.up('xl')]: {
      width: `60%`,
    },
  },
  icon: {
    [theme.breakpoints.up('xs')]: {
      minWidth: '15px'
    },
    [theme.breakpoints.up('sm')]: {
      width: `10%`,
    },
    [theme.breakpoints.up('md')]: {
      width: `10%`,
    },
    [theme.breakpoints.up('lg')]: {
      width: `10%`,
    },
    [theme.breakpoints.up('xl')]: {
      width: `10%`,
    },
  },
  iconviewhistorial: {
    width: `100%`,
    /*  [theme.breakpoints.up('xs')]: {
         width: `100%`,
     },
     [theme.breakpoints.up('sm')]: {
         width: `80%`,
     },
     [theme.breakpoints.up('md')]: {
         width: `80%`,
     },
     [theme.breakpoints.up('lg')]: {
         width: `80%`,
     },
     [theme.breakpoints.up('xl')]: {
         width: `80%`,
     }, */
  },
  stylenumberaccount: {
    color: '#b98919',
    fontSize: 18,
    //fontFamily: 'MyriadPro-Bold',
  },
  stylesaldoaccount: {
    fontSize: 12,
    color: '#b98919',
    marginLeft: isMobile ? 0 : "20%"
    //fontFamily: 'MyriadPro-Bold',
  },
  buttonViewMovements: {
    [theme.breakpoints.up('xs')]: {
      color: '#0073D2',
      fontSize: '50%',
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up('sm')]: {
      color: '#0073D2',
      fontSize: '80%',
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up('md')]: {
      color: '#0073D2',
      fontSize: '80%',
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up('lg')]: {
      color: '#0073D2',
      fontSize: '80%',
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up('xl')]: {
      color: '#0073D2',
      fontSize: '80%',
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
  },
  styleItemTypeProductInactive: {
    color: '#FFFFFF',
    backgroundColor: "#2E2757",
    "&:hover": {
      color: '#FFFFFF',
      backgroundColor: "#2E2757",
    }
  },
  styleItemTypeProductActive: {
    color: '#FFFFFF',
    backgroundColor: "#2E2757",
    "&:hover": {
      color: '#FFFFFF',
      backgroundColor: "#2E2757",
    }
  },
  containerButton: {
    position: 'relative',
    transform: 'none',
    display: 'flex',
    justifyContent: 'end',
    right: '0px',
  },
  buttonGetMovements: {
    borderRadius: '8px',
    fontSize: '0.6rem',
    color: '#fff',
    backgroundColor: "#2E2757",
    //fontFamily: 'MyriadPro-Bold',
  },
  tabDisable: {
    fontSize: 12,
    color: '#898989',
    backgroundColor: theme.palette.type === 'dark' ? 'inherit' : "#efefef",
    textTransform: "inherit",
    '&.MuiTab-textColorInherit.Mui-selected': {
      backgroundColor: theme.palette.type === 'dark' ? 'inherit' : "#fff",
      color: theme.palette.type === 'dark' ? '#b98919' : "#2e2757",
      borderBottom: `2px solid ${theme.palette.type === 'dark' ? '#b98919' : "#2e2757"}`
    }
  },
  iconStyle: {
    marginTop: isMobile ? '-290px' : '-400px',
    fontSize: isMobile ? '3rem' : '4rem',
    fill: '#CD9E32',
    stroke: '#2E2657',
    strokeWidth: 1,
    marginRight: '10px'

  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'fixed',
    bottom: '20px',
    right: isMobile ? '10px' : '20px',
    marginTop: isMobile ? '-200px' : '-350px',
    marginRight: '10px'
  },
  text: {
    fontSize: '1rem',
    color: '#000',
    marginTop: '-180px',
    marginRight: '10px'
  },
}));

const UserInfo = props => {
  const { balances, skeleton, credits, /* balancesjoint, */ deposits/* , creditsDetails */ } = props
  const permissions = useSelector(state => state.permissions)


  const [value, setValue] = React.useState(0);
  const [visibleBalances, setVisibleBalances] = useState(true);

  const toggleVisibility = () => {
    setVisibleBalances(!visibleBalances);
  };


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const classes2 = useStyles()

  const handleMaskNumberAccount = (numberBeneficiary) => {

    if (numberBeneficiary.length > 7) {

      let resultConvert = ""

      const [a, b, c, d, ...dataConvert] = numberBeneficiary

      const inicioFin = dataConvert.length - 3

      const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

      for (let y = 0; y < inicioFin; y++) {
        resultConvert = resultConvert.concat("X")
      }

      resultConvert = a + b + c + d + resultConvert + ultimos

      return resultConvert

    } else {

      return numberBeneficiary

    }
  }

  const renderDetailSavingsAccount = (numeroCuenta, saldo) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <div style={{ flex: '1', maxWidth: '73%' }}>
          <Typography className={isMobile ? classes2.textAccountsMobile : classes2.textaccounts}>
            <span className={classes2.stylenumberaccount}>{`${handleMaskNumberAccount(numeroCuenta)} `}</span>
            <br />
            <span style={{ color: "#898989" }}>Saldo: ${<span className={classes2.stylesaldoaccount}> {`${parseFloat(saldo).toFixed(2)} `}</span>}</span>
          </Typography>
        </div>
      </div>
    )
  }

  const renderDetailFixedTermDeposits = (monto, numero, fechavencimiento, estado) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <div style={{ flex: '1', maxWidth: '73%' }}>
          <Typography className={isMobile ? classes2.textAccountsMobile : classes2.textaccounts}>
            <span style={{ color: "#898989" }}>Monto: ${<span className={classes2.stylesaldoaccount}> {`${parseFloat(monto).toFixed(2)}`}</span>}</span>
            <br />
            <span style={{ color: "#898989" }}>Número:{<span className={classes2.stylesaldoaccount}> {`${numero} `}</span>}</span>
            <br />
            <span style={{ color: "#898989" }}>Vencimiento: {<span className={classes2.stylesaldoaccount}> {`${moment(fechavencimiento).format('DD/MM/YYYY')} `}</span>}</span>
            <br />
            <span style={{ color: "#898989" }}>Tasa: {<span className={classes2.stylesaldoaccount}> {`${estado} `}</span>}</span>

          </Typography>
        </div>
      </div>
    )

  }

  const renderDetailCredits = (saldo, cuotasPagadas, totalCuotas) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <div style={{ flex: '1', maxWidth: '73%' }}>
          <Typography className={isMobile ? classes2.textAccountsMobile : classes2.textaccounts}>
            <span style={{ color: "#898989" }}>Saldo: ${<span className={classes2.stylesaldoaccount}> {`${parseFloat(saldo).toFixed(2)}`}</span>}</span>
            <br />
            <span style={{ color: "#898989" }}>Cuotas Pagadas: {<span className={classes2.stylesaldoaccount}> {`${cuotasPagadas}`}</span>}</span>
            <br />
            <span style={{ color: "#898989" }}>Total de Cuotas: {<span className={classes2.stylesaldoaccount}> {`${totalCuotas}`}</span>}</span>
            <br />
          </Typography>
        </div>
      </div>
    );
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3} style={{ padding: "0 8px" }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  if (skeleton) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12} sm={12}>
          <br />
          {<Skeleton variant="text" />}
          <br />
          {<Skeleton variant="text" />}
          <br />
          <Skeleton variant="text" />
          <br />

        </Grid>
      </Grid>)

  } else {
    return (
      <Paper elevation={0} container spacing={1} className={classes2.styleAll}>
        <Grid item xs={12} md={12} lg={12} sm={12}>
          <AppBar position="static" style={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="fullWidth"
              TabIndicatorProps={{
                hidden: true
              }}
              aria-label="simple tabs example"
              style={{ borderRadius: "10px 10px 0 0", border: "1px solid #898989" }}
            >
              <Tab label="Cuenta de ahorros" {...a11yProps(0)} className={classes2.tabDisable} style={{ borderRight: "1px solid #898989" }} />
              <Tab label="Depósitos a plazo" {...a11yProps(1)} className={classes2.tabDisable} style={{ borderRight: "1px solid #898989" }} />
              <Tab label="Créditos" {...a11yProps(2)} className={classes2.tabDisable} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <div style={{ textAlign: 'end' }}>
              {permissions.includes(11) && <Button color='primary' style={{ width: 'auto' }} onClick={toggleVisibility} endIcon={visibleBalances ? <Icon>visibility</Icon> : <Icon>visibility_off</Icon>}>
                {visibleBalances ? 'Mostrar todo' : 'Ocultar todo'}
              </Button>}
            </div>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              style={{ height: !isMobile && 300, overflowY: "auto", position: 'relative', display: 'flex', flexDirection: 'column' }}
            >
              {balances.map((b, index) => (
                <ListItem key={b.PRODUCTBANKID} style={{ paddingLeft: '0px', paddingRight: '0px', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                  <ListItemAvatar>
                    <Icon>wysiwyg</Icon>
                  </ListItemAvatar>
                  <ListItemText style={{ flex: 1 }}
                    primary={<Typography className={classes2.textAccountsMobile} align="left" style={{ textWrap: 'nowrap' }}>{b.PRODUCTALIAS}</Typography>}
                    secondary={
                      visibleBalances ? (
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                          <div style={{ flex: '1', maxWidth: '73%' }}>
                            <Typography className={isMobile ? classes2.textAccountsMobile : classes2.textaccounts} style={{ textAlign: 'justify' }}>
                              <span className={classes2.stylenumberaccount}>*****</span>
                              <br />
                              <span style={{ color: "#898989" }}>Saldo: ${<span className={classes2.stylesaldoaccount}> *****</span>}</span>
                            </Typography>
                          </div>
                        </div>
                      ) : (
                        renderDetailSavingsAccount(b.PRODUCTBANKID.slice(4), b.SALDOINT)
                      )
                    }
                  />
                  {permissions.includes(11) && <ListItemSecondaryAction style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: "8px", right: "1px", position: "absolute", bottom: 0 }}>
                    <IconButton size="small" onClick={() => history.push(`/movements/${b.PRODUCTBANKID}`)}>
                      <span style={{ fontSize: "14px" }}>Detalles</span>
                      <ArrowForwardIos />
                    </IconButton>
                  </ListItemSecondaryAction>}
                </ListItem>
              ))}
            </List>
          </TabPanel>

          <TabPanel value={value} index={1}>
            {deposits.length > 0 && (
              <Button onClick={toggleVisibility} size="small">
                {visibleBalances ? <Icon>visibility_off</Icon> : <Icon>visibility</Icon>}
              </Button>
            )}
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              style={{ height: !isMobile && 300, overflowY: "auto", position: 'relative', display: 'flex', flexDirection: 'column' }}
            >
              {deposits.length > 0 ? (
                deposits.map((b, index) => (
                  <ListItem key={b.PRODUCTBANKID} style={{ paddingLeft: '0px', paddingRight: '0px', position: 'relative', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <ListItemAvatar>
                      <Icon>payments</Icon>
                    </ListItemAvatar>
                    <ListItemText
                      primary={<Typography className={classes2.textAccountsMobile} align="left" style={{ textWrap: 'nowrap' }}>{b.PRODUCTALIAS}</Typography>}
                      secondary={
                        visibleBalances ? (
                          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ flex: '1', maxWidth: '73%' }}>
                              <Typography className={isMobile ? classes2.textAccountsMobile : classes2.textaccounts} style={{ textAlign: 'justify' }}>
                                <span style={{ color: "#898989" }}>Monto: ${<span className={classes2.stylesaldoaccount}> *****</span>}</span>
                                <br />
                                <span style={{ color: "#898989" }}>Número: {<span className={classes2.stylesaldoaccount}> *****</span>}</span>
                                <br />
                                <span style={{ color: "#898989" }}>Vencimiento: {<span className={classes2.stylesaldoaccount}> *****</span>}</span>
                                <br />
                                <span style={{ color: "#898989" }}>Tasa: {<span className={classes2.stylesaldoaccount}> *****</span>}</span>
                              </Typography>
                            </div>
                          </div>
                        ) : (
                          renderDetailFixedTermDeposits(b.SALDOINT, b.PRODUCTBANKID.slice(4), b.EXPIRATIONDATE, b.RATE)
                        )
                      }
                    />
                    <ListItemSecondaryAction style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: "8px", right: "1px", position: "absolute", bottom: 0 }}>
                      <IconButton size="small" color='#2E2657' onClick={() => history.push(`/movements-deposits/${b.PRODUCTBANKID}`)}>
                        <span className="material-symbols-outlined">
                          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#2E2657" style={{ fill: '#2E2657' }}>
                            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v333q-19-11-38.5-20T760-463v-57H627v40q-21 1-41 3t-39 7v-50H413v111q-24 18-45.5 40.5T328-320H200v120h82q10 22 21.5 42t24.5 38H200Zm0-280h133v-120H200v120Zm0-200h560v-160H200v160ZM640-40q-91 0-168-48T360-220q35-84 112-132t168-48q91 0 168 48t112 132q-35 84-112 132T640-40Zm0-80q57 0 107.5-26t82.5-74q-32-48-82.5-74T640-320q-57 0-107.5 26T450-220q32 48 82.5 74T640-120Zm0-40q-25 0-42.5-17.5T580-220q0-25 17.5-42.5T640-280q25 0 42.5 17.5T700-220q0 25-17.5 42.5T640-160Z" />
                          </svg>
                        </span>
                      </IconButton>
                      <span style={{ color: "#2E2657", fontSize: "10px", marginTop: "-8px" }}>Movimientos</span>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              ) : (
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography className={classes2.textAccountsMobile} align="center" style={{ backgroundColor: '#F4F4F4', color: '#2E2657', borderRadius: '8px', padding: '8px' }}>
                        No tiene Depósitos a plazo fijo disponibles
                      </Typography>
                    }
                  />
                </ListItem>
              )}
            </List>
          </TabPanel>

          <TabPanel value={value} index={2}>
            {credits.length > 0 && (
              <Button onClick={toggleVisibility} size="small">
                {visibleBalances ? <Icon>visibility_off</Icon> : <Icon>visibility</Icon>}
              </Button>
            )}
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              style={{ height: !isMobile && 300, overflowY: "auto", position: 'relative', display: 'flex', flexDirection: 'column' }}
            >
              {credits.length > 0 ? (
                credits.map((b, index) => (
                  <ListItem key={b.PRODUCTBANKID} style={{ paddingLeft: '0px', paddingRight: '0px', position: 'relative', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <ListItemAvatar>
                      <Icon>sell</Icon>
                    </ListItemAvatar>
                    <ListItemText
                      primary={<Typography className={classes2.textAccountsMobile} align="left" style={{ textWrap: 'nowrap' }}>{b.PRODUCTALIAS}</Typography>}
                      secondary={
                        visibleBalances ? (
                          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ flex: '1', maxWidth: '73%' }}>
                              <Typography className={isMobile ? classes2.textAccountsMobile : classes2.textaccounts} style={{ textAlign: 'justify' }}>
                                <div style={{ color: "#898989" }}>Saldo: ${<span className={classes2.stylesaldoaccount}> *****</span>}</div>
                                <div style={{ color: "#898989" }}>Cuotas Pagadas: {<span className={classes2.stylesaldoaccount}> *****</span>}</div>
                                <div style={{ color: "#898989" }}>Total de Cuotas: {<span className={classes2.stylesaldoaccount}> *****</span>}</div>
                              </Typography>
                            </div>
                          </div>
                        ) : (
                          renderDetailCredits(b.SALDOINT, b.CUOTASPAG, b.CUOTASTOTALES)
                        )
                      }
                    />
                    <ListItemSecondaryAction style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: "9px", right: "1px", position: "absolute", bottom: 0 }}>
                      <IconButton size="small" color='#2E2657' onClick={() => history.push(`/movements-credits/${b.PRODUCTBANKID}`)}>
                        <span className="material-symbols-outlined">
                          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#2E2657" style={{ fill: '#2E2657' }}>
                            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v333q-19-11-38.5-20T760-463v-57H627v40q-21 1-41 3t-39 7v-50H413v111q-24 18-45.5 40.5T328-320H200v120h82q10 22 21.5 42t24.5 38H200Zm0-280h133v-120H200v120Zm0-200h560v-160H200v160ZM640-40q-91 0-168-48T360-220q35-84 112-132t168-48q91 0 168 48t112 132q-35 84-112 132T640-40Zm0-80q57 0 107.5-26t82.5-74q-32-48-82.5-74T640-320q-57 0-107.5 26T450-220q32 48 82.5 74T640-120Zm0-40q-25 0-42.5-17.5T580-220q0-25 17.5-42.5T640-280q25 0 42.5 17.5T700-220q0 25-17.5 42.5T640-160Z" />
                          </svg>
                        </span>
                      </IconButton>
                      <span style={{ color: "#2E2657", fontSize: "10px", marginTop: "-8px" }}>Movimientos</span>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              ) : (
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography className={classes2.textAccountsMobile} align="center" style={{ backgroundColor: '#F4F4F4', color: '#2E2657', borderRadius: '8px', padding: '8px' }}>
                        No tiene créditos disponibles
                      </Typography>
                    }
                  />
                </ListItem>
              )}
            </List>
          </TabPanel>
        </Grid>

      </Paper>
    );
  }
};

UserInfo.propTypes = {
  customer: PropTypes.object.isRequired,
};

export default UserInfo;
